import {
  ArrowsLeftRightIcon,
  ArrowUDownLeftIcon,
  CoinsIcon,
  HandbagIcon,
  ShuffleIcon,
  TShirtIcon,
} from '@phosphor-icons/react'

import { deliveryMethodNames, deliveryMethods as deliveryMethodsValues } from '@reveni-io/reveni-ui'

import { filterNames } from '../constants'

export { transactionStatuses as statuses } from '@/common/constants'

export const deliveryMethods = [
  {
    label: deliveryMethodNames.returntostore,
    value: deliveryMethodsValues.returntostore,
  },
  {
    label: deliveryMethodNames.pickuppoint,
    value: deliveryMethodsValues.pickuppoint,
  },
  {
    label: deliveryMethodNames.customerpickup,
    value: deliveryMethodsValues.customerpickup,
  },
  {
    label: deliveryMethodNames.customerdelivers,
    value: deliveryMethodsValues.customerdelivers,
  },
]

const sectionIds = {
  transactions: 'transactions',
  refundPayment: 'refundPayment',
  products: 'products',
  return: 'return',
  order: 'order',
  exchangeOrder: 'exchangeOrder',
}

export const sections = [
  {
    label: 'Transacción',
    id: sectionIds.transactions,
    Icon: ShuffleIcon,
  },
  {
    label: 'Reembolso / Pago',
    id: sectionIds.refundPayment,
    Icon: CoinsIcon,
  },
  {
    label: 'Productos',
    id: sectionIds.products,
    Icon: TShirtIcon,
  },
  {
    label: 'Devolución',
    id: sectionIds.return,
    Icon: ArrowUDownLeftIcon,
  },
  {
    label: 'Pedido',
    id: sectionIds.order,
    Icon: HandbagIcon,
  },
  {
    label: 'Pedido de cambio',
    id: sectionIds.exchangeOrder,
    Icon: ArrowsLeftRightIcon,
  },
]

export const amountFilterConfig = {
  [filterNames.refundTotalAmount]: {
    field: 'refund_total_amount',
    matchTypeName: 'refundTotalAmountMatchType',
    eq: filterNames.refundTotalAmount,
    gt: filterNames.refundTotalAmountGt,
    lt: filterNames.refundTotalAmountLt,
    gte: filterNames.refundTotalAmountGte,
    lte: filterNames.refundTotalAmountLte,
  },
  [filterNames.paymentTotalAmount]: {
    field: 'payment_total_amount',
    matchTypeName: 'paymentTotalAmountMatchType',
    eq: filterNames.paymentTotalAmount,
    gt: filterNames.paymentTotalAmountGt,
    lt: filterNames.paymentTotalAmountLt,
    gte: filterNames.paymentTotalAmountGte,
    lte: filterNames.paymentTotalAmountLte,
  },
}

export const amountFilterNames = Object.keys(amountFilterConfig)

export const amountBoundKeys = ['eq', 'gt', 'lt', 'gte', 'lte']

export const matchModes = { all: 'all', any: 'any' }

export const matchModeFilterNames = {
  [filterNames.transactionTags]: filterNames.transactionTagsMatch,
  [filterNames.policyRules]: filterNames.policyRulesMatch,
  [filterNames.pendingAlertTypes]: filterNames.pendingAlertTypesMatch,
}

export const filterTypes = [
  { label: 'Tipo de transacción', value: filterNames.transactionType, section: sectionIds.transactions },
  { label: 'Modo de transacción', value: filterNames.instant, section: sectionIds.transactions },
  { label: 'Estado de transacción', value: filterNames.status, section: sectionIds.transactions },
  { label: 'Etiquetas de transacción', value: filterNames.transactionTags, section: sectionIds.transactions },
  { label: 'Fecha de solicitud', value: filterNames.refundDate, section: sectionIds.transactions },
  { label: 'Última actualización', value: filterNames.lastUpdate, section: sectionIds.transactions },
  { label: 'Días para validar', value: filterNames.expiresIn, section: sectionIds.transactions },
  { label: 'Tiene alertas pendientes', value: filterNames.hasAlerts, section: sectionIds.transactions },
  { label: 'Tipos de alerta', value: filterNames.pendingAlertTypes, section: sectionIds.transactions },
  { label: 'Tiene Policy Rules aplicadas', value: filterNames.hasPolicyRules, section: sectionIds.transactions },
  { label: 'Policy Rules aplicadas', value: filterNames.policyRules, section: sectionIds.transactions },
  { label: 'Método de reembolso', value: filterNames.refundMethod, section: sectionIds.refundPayment },
  { label: 'Estado de pago', value: filterNames.paymentStatus, section: sectionIds.refundPayment },
  { label: 'Estado de reembolso', value: filterNames.refundStatus, section: sectionIds.refundPayment },
  { label: 'Contiene productos', value: filterNames.variantsSkus, section: sectionIds.products },
  {
    label: 'Contiene productos con motivo de devolución',
    value: filterNames.returnReason,
    section: sectionIds.products,
  },
  {
    label: 'Contiene productos con motivo de rechazo',
    value: filterNames.rejectReason,
    section: sectionIds.products,
  },
  {
    label: 'Contiene productos con motivo de revisión',
    value: filterNames.forReviewReason,
    section: sectionIds.products,
  },
  {
    label: 'Contiene productos de categoría',
    value: filterNames.productCategory,
    section: sectionIds.products,
  },
  {
    label: 'Contiene productos de un tipo',
    value: filterNames.productType,
    section: sectionIds.products,
  },
  {
    label: 'Contiene productos de colección',
    value: filterNames.productCollection,
    section: sectionIds.products,
  },
  {
    label: 'Contiene regalos',
    value: filterNames.isGift,
    section: sectionIds.products,
  },
  { label: 'Tipo de método de devolución', value: filterNames.deliveryMethodType, section: sectionIds.return },
  { label: 'Método de devolución', value: filterNames.deliveryMethod, section: sectionIds.return },
  { label: 'Transportista devolución', value: filterNames.carrier, section: sectionIds.return },
  { label: 'Estado etiquetas de devolución', value: filterNames.shippingLabelStatus, section: sectionIds.return },
  { label: 'Región de la devolución', value: filterNames.region, section: sectionIds.return },
  { label: 'Estado de pedido de cambio', value: filterNames.exchangeForOrderStatus, section: sectionIds.exchangeOrder },
  {
    label: 'Fecha de creación pedido de cambio',
    value: filterNames.exchangeCreatedDate,
    section: sectionIds.exchangeOrder,
  },
  {
    label: 'Tipo de cambio solicitado',
    value: filterNames.exchangedType,
    section: sectionIds.exchangeOrder,
  },
  {
    label: 'Fecha emisión reembolso',
    value: filterNames.refundCreatedDate,
    section: sectionIds.refundPayment,
  },
  {
    label: 'Tipo de pedido',
    value: filterNames.orderType,
    section: sectionIds.order,
  },
  {
    label: 'Importe total del reembolso',
    value: filterNames.refundTotalAmount,
    section: sectionIds.refundPayment,
  },
  {
    label: 'Importe total del pago',
    value: filterNames.paymentTotalAmount,
    section: sectionIds.refundPayment,
  },
]
